import { render, staticRenderFns } from "./CountDiseaseGraphic.vue?vue&type=template&id=3c7d390f&scoped=true&"
import script from "./CountDiseaseGraphic.vue?vue&type=script&lang=js&"
export * from "./CountDiseaseGraphic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7d390f",
  null
  
)

export default component.exports